import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-949ea760"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate codebite" }
const _hoisted_2 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_3 = { class: "modal-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "¿Estás seguro de que deseas borrar este Post?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esta acción no se puede deshacer", -1))
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = { class: "codebite-title" }
const _hoisted_8 = { class: "codebite-content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = { class: "social-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "social" }
const _hoisted_16 = {
  key: 0,
  class: "profile"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "profile"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "...", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "user-name"
}
const _hoisted_23 = {
  key: 1,
  class: "user-name"
}
const _hoisted_24 = { style: {"font-size":"18px"} }

import { ref, onMounted } from 'vue'
import ChannelService from '@/services/ChannelService'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import ProfileService from '@/services/ProfileService'


export default /*#__PURE__*/_defineComponent({
  __name: 'CodePost',
  props: ['codepost', 'user'],
  emits: ['refresh'],
  setup(__props, { emit: __emit }) {

const toast = useToast()
const props = __props
const emit = __emit
const likes = ref(0)
const service = new ChannelService()
const isSaved = ref(false)
const liked = ref(false)
const store = useAuth()
const showDelete = ref(false)
const profileService = new ProfileService()
const isOwner = ref(false)

onMounted(async () => {
    likes.value = await service.CountCodePostLikes(props.codepost.id)

    if(!store.token) { return}
    isSaved.value = await service.CheckIfCodePostIsStored(store.token, props.codepost.id)
    liked.value = await service.CheckIfCodePostIsLiked(store.token, props.codepost.id)
    const user = await profileService.MyUser(store.token)
    if(user.id == props.user.id) { isOwner.value = true}
})

const readMore = () => {
    router.push({name: 'codepost-view', params: {id: props.codepost.id}})
}

const handleDelete = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await service.DeleteCodePost(store.token, props.codepost.id)
    if(response.success) {
        toast.showToast("Post Borrado", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000)
        emit('refresh')
        showDelete.value = false
        return
    } else {
        toast.showToast(response.message, Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        showDelete.value = false
    }
}

const handleStoreCodePost = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    await service.MarkCodePostAsSaved(store.token, props.codepost.id)
    toast.showToast("Post guardado. Puedes ver tus Posts guardados en la sección del menú Posts guardados (Mi Sección)", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 8000);
    isSaved.value = true
}

const handleUndoStoreCodePost = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    await service.UndoCodePostAsSaved(store.token, props.codepost.id)
    toast.showToast("Eliminado de tus Posts guardados", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    isSaved.value = false
}

const handleDoCodePostLike = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    await service.DoCodePostLike(store.token, props.codepost.id)
    toast.showToast("Te gusta este Post", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    likes.value++
    liked.value = true;
}

const handleUndoCodePostLike = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    await service.UndoCodePostLike(store.token, props.codepost.id)
    toast.showToast("Ya no te gusta este Post", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    likes.value--
    liked.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showDelete.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              style: {"float":"right","cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDelete.value = false))
            }, [
              _createVNode(_component_v_icon, {
                name: "ri-close-circle-fill",
                fill: "lightcoral"
              })
            ]),
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "new-question",
                onClick: handleDelete,
                style: {"background-color":"lightcoral","color":"white"}
              }, "Borrar Post"),
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showDelete.value = false))
              }, "Cancelar")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h3", null, [
        _createTextVNode(_toDisplayString(props.codepost.title) + " ", 1),
        (isOwner.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "delete-icon",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showDelete.value = true))
            }, [
              _createVNode(_component_v_icon, {
                name: "md-delete",
                class: "ver",
                fill: "lightcoral",
                scale: "1"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: props.codepost.image_uri,
        style: {"width":"100%"}
      }, null, 8, _hoisted_9),
      _hoisted_10,
      _createElementVNode("div", {
        innerHTML: props.codepost.short_description
      }, null, 8, _hoisted_11),
      _hoisted_12,
      _createElementVNode("button", {
        class: "read-more-codepost",
        onClick: readMore
      }, "Leer Post")
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (props.codepost.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (props.codepost.user.profile_picture_uri)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: props.codepost.user.profile_picture_uri
                  }, null, 8, _hoisted_17))
                : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.codepost.user.name.substring(0, 2)), 1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)),
        _createVNode(_component_RouterLink, {
          to: {name:'social-profile', params: {id: props.user.id}},
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            (props.user.nickname)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_22, "@" + _toDisplayString(props.user.nickname), 1))
              : (_openBlock(), _createElementBlock("h5", _hoisted_23, "@" + _toDisplayString(props.user.name.substring(0,3)) + _toDisplayString(props.user.id), 1))
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("h5", _hoisted_24, _toDisplayString(likes.value), 1),
        (!liked.value)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 2,
              class: "code-bite-icon",
              name: "bi-hand-thumbs-up-fill",
              onClick: handleDoCodePostLike
            }))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 3,
              class: "code-bite-icon-marked",
              name: "bi-hand-thumbs-up-fill",
              onClick: handleUndoCodePostLike
            })),
        (!isSaved.value)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 4,
              class: "code-bite-icon",
              name: "md-save-sharp",
              onClick: handleStoreCodePost
            }))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 5,
              class: "code-bite-icon-marked",
              name: "md-save-sharp",
              onClick: handleUndoStoreCodePost
            }))
      ])
    ])
  ]))
}
}

})